import React, { useState, useEffect } from "react";
import { useAuthContext } from "../../../context/AuthContext";
import { notifications } from "../../../utils/api/notifications";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { viewCurrentNotification } from "../../../utils/api/viewCurrentNotification";
import { Skeleton } from "antd";
import Button from "../Button";

const NotificationList = ({ onClose }) => {
  const [notificationsData, setNotificationsData] = useState([]);
  const { authUser } = useAuthContext();
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    fetchData();
    return () => {
      document.body.classList.remove("overflow-hidden");
      document.body.style.width = "";
    };
  }, []);

  const fetchData = async () => {
    document.body.style.width = "calc(100% - 17px)";
    document.body.classList.add("overflow-hidden");
    try {
      setIsLoading(true);
      const { data } = await notifications(authUser);
      setNotificationsData((prevData) => [...prevData, ...data]);
      document.body.classList.add("overflow-hidden");
    } catch (error) {
      console.log(error);
      setIsLoading(false);
    } finally {
      setIsLoading(false);
    }
  };

  const formatDateToday = (createdAt) => {
    const now = moment();
    const then = moment(createdAt);
    const diff = now.diff(then, "minutes");

    if (diff < 60) {
      return `${diff} minute${diff === 1 ? "" : "s"} ago`;
    } else {
      return then.format("h:mm A");
    }
  };

  const formatDateOlder = (createdAt) => {
    return moment(createdAt).format("DD MMM YYYY");
  };

  const handleNotificationClick = (redirectionString) => {
    if (redirectionString) {
      navigate(redirectionString);
    }
  };
  const handleCurrentNotificationClick = async (id) => {
    try {
      await viewCurrentNotification(authUser, id);
    } catch (error) {
      console.error("Error updating notification status:", error);
    }
  };

  const todayNotifications = notificationsData.filter((notification) => {
    const createdAtDate = new Date(notification.createdAt).toLocaleDateString();
    const todayDate = new Date().toLocaleDateString();
    return createdAtDate === todayDate;
  });

  const olderNotifications = notificationsData.filter((notification) => {
    const createdAtDate = new Date(notification.createdAt).toLocaleDateString();
    const todayDate = new Date().toLocaleDateString();
    return createdAtDate !== todayDate;
  });

  const handleSeeMoreClick = () => {
    fetchData();
  };

  return (
    <>
      <div
        className="fixed top-0 left-0 w-full h-full bg-black opacity-50 z-50"
        onClick={onClose}
      ></div>
      <div className="fixed top-12 right-8 w-[400px] bg-white m-4 shadow-md rounded-2xl z-50">
        <div className="text-base font-bold mt-4 px-6">Notification</div>
        <br />
        <div className="px-6 h-[455px] overflow-y-auto">
          <div>
            {isLoading && (
              <>
                <div className="flex flex-col gap-y-4 p-4">
                  <Skeleton.Button block={true} active={true} />
                  <Skeleton.Button block={true} active={true} />
                  <Skeleton.Button block={true} active={true} />
                  <Skeleton.Button block={true} active={true} />
                  <Skeleton.Button block={true} active={true} />
                  <Skeleton.Button block={true} active={true} />
                  <Skeleton.Button block={true} active={true} />
                  <Skeleton.Button block={true} active={true} />
                  <Skeleton.Button block={true} active={true} />
                </div>
              </>
            )}
            {!isLoading && notificationsData.length === 0 ? (
              <p className="text-center text-sm text-gray-500 py-6">
                No notifications found yet.
              </p>
            ) : (
              <>
                {!isLoading && todayNotifications.length > 0 && (
                  <p className="text-xs font-bold text-grey-500 py-2">Today</p>
                )}
                <ul className="text-xs cursor-pointer">
                  {todayNotifications.map((notification, index) => (
                    <div key={index} className="pt-2">
                      <div className="flex gap-3">
                        <div className="w-[10px] h-[9px] rounded-full mt-1 bg-blue-800"></div>
                        <li
                          onClick={() => {
                            handleNotificationClick(
                              notification.redirectionString
                            );
                            handleCurrentNotificationClick(notification._id);
                          }}
                        >
                          {notification.content}
                        </li>
                      </div>
                      <p className="text-xs font-bold ml-5 pt-2 mb-[5px] text-grey-500">
                        {formatDateToday(notification.createdAt)}
                      </p>
                      <br />
                    </div>
                  ))}
                </ul>
                {olderNotifications.length > 0 && (
                  <>
                    <p className="text-xs font-bold text-grey-500 py-2">
                      Older
                    </p>
                    <ul className="text-xs cursor-pointer">
                      {olderNotifications.map((notification, index) => (
                        <div key={index} className="mt-2">
                          <div className="flex">
                            <div className="w-[10px] h-[9px] rounded-full mt-1 mr-3 bg-grey-500"></div>
                            <li
                              onClick={() =>
                                handleNotificationClick(
                                  notification.redirectionString
                                )
                              }
                            >
                              {notification.content}
                            </li>
                          </div>
                          <p className="text-xs font-bold ml-5 pt-2 mb-[5px] text-grey-500">
                            {formatDateOlder(notification.createdAt)}
                          </p>
                          <br />
                        </div>
                      ))}
                    </ul>
                  </>
                )}
              </>
            )}
            <div className="text-center my-3">
              <Button
                color={"blue"}
                varient={"secondary"}
                className={"text-white text-center text-xs px-3 py-1"}
                onClick={handleSeeMoreClick}
              >
                See more
              </Button>
            </div>
            <div className="mb-8"></div>
          </div>
        </div>
      </div>
    </>
  );
};

export default NotificationList;
